var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8238 12.5144C23.7975 11.7599 23.7056 11.046 23.5667 10.3529L12.7755 10.7297L12.9259 15.0367L19.1045 14.8209C18.8769 16.2439 18.1069 17.466 16.932 18.3197L17.032 21.1847L20.7182 21.0559C22.8068 18.9847 23.9455 16 23.8238 12.5144Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2423 24.0992C16.3365 23.9912 18.8884 22.8694 20.7182 21.0558L16.932 18.3196C15.9246 19.0432 14.631 19.5091 13.0839 19.5631C10.0949 19.6675 7.49383 17.7409 6.49156 15.0509L2.69077 15.1836L2.79381 18.1345C4.80584 21.8123 8.76352 24.2556 13.2423 24.0992Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49156 15.051C6.2288 14.3718 6.07898 13.6408 6.0523 12.8768C6.02562 12.1128 6.13364 11.3728 6.33882 10.6772L6.23577 7.72635L2.43498 7.85908C1.70592 9.43348 1.31778 11.1872 1.38248 13.0399C1.44717 14.8925 1.9567 16.6149 2.79381 18.1346L6.49156 15.051Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6004 5.71607C14.2907 5.65704 15.8199 6.18689 17.0533 7.28162L20.2053 3.90156C18.1638 2.11794 15.5361 1.0719 12.442 1.17995C7.96317 1.33635 4.18557 4.04984 2.435 7.85904L6.33884 10.6772C7.15102 7.92382 9.61134 5.82045 12.6004 5.71607Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9333,
    height: 22.9333,
    fill: "white",
    transform: "translate(0.738739 1.58862) rotate(-2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4b8322c21fb9857120c95078690bfc23.svg";
export { ForwardRef as ReactComponent };